// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-Rxu6lQ","dots":"dots-FxRjUl","dot1":"dot1-cHF5xs","dot2":"dot2-AtyeI8","dot3":"dot3-e_Sm3D","dotPulse":"dotPulse-i9Rf_C","label":"label-nQCXjh"};